module.exports = __webpack_public_path__ + "assets/img/news (37).d1ae5281.png";